import React, { useState } from 'react';
import '../styles/SortBy.css';

const SortBy = ({ onSortChange }) => {
  const [sortBy, setSortBy] = useState('relevance');

  const sortOptions = [
    { label: 'Popularity', value: 'relevance' },
    { label: 'Latest', value: 'newest' },
    { label: 'Discount', value: 'discount' },
    { label: 'Price: High to Low', value: 'price-high' },
    { label: 'Price: Low to High', value: 'price-low' },
    { label: 'Customer Rating', value: 'rating' },
  ];

  const handleSort = (e) => {
    setSortBy(e.target.value);
    onSortChange(e.target.value);
  };

  return (
    <div className="sort-by-container">
      <label htmlFor="sort-select">Sort By:</label>
      <select id="sort-select" value={sortBy} onChange={handleSort} className="sort-select">
        {sortOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SortBy;
